import { PostDetailFragment, PostTypeEnum } from "@/generated/generated-hooks";

export const useIsPostLocked = (
  post: Pick<
    PostDetailFragment,
    "postType" | "userBlurLevel" | "isUserContentLocked" | "videoUri"
  >,
) => {
  const { postType, userBlurLevel, isUserContentLocked, videoUri } = post;

  if (postType === PostTypeEnum.Normal) return userBlurLevel !== 0;
  if (postType === PostTypeEnum.Article) return isUserContentLocked;
  if (postType === PostTypeEnum.Video) return !videoUri;

  return false;
};
